import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18Myshopping2 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M11.2 5.29a.6.6 0 0 1 .592.503l.008.097v1.214A2.607 2.607 0 0 1 9.245 9.6a2.604 2.604 0 0 1-2.523-2.347L6.71 7.08V5.89a.6.6 0 0 1 1.192-.097l.008.097v1.166c.029.738.626 1.326 1.332 1.344a1.4 1.4 0 0 0 1.346-1.188l.012-.132V5.89a.6.6 0 0 1 .6-.6"
      }), /*#__PURE__*/jsx("path", {
        d: "M13.41 2.1h-8.3l-.154.01a2.055 2.055 0 0 0-1.852 1.908l-.002.068-.997 9.752c-.005 1.224.913 2.142 2.045 2.142h10.22a2.05 2.05 0 0 0 2.04-2.068l-.954-9.85C15.45 3.019 14.542 2.11 13.41 2.1M5.141 3.9h8.261a.26.26 0 0 1 .258.258l.954 9.85-.045.06-.03.037a.25.25 0 0 1-.177.075H4.15a.25.25 0 0 1-.25-.25l.995-9.678.005-.1a.25.25 0 0 1 .241-.253z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Myshopping2$1 = Svg18Myshopping2;

export { Svg18Myshopping2$1 as default };
